import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=052f6d43&"
import script from "./Records.vue?vue&type=script&lang=ts&"
export * from "./Records.vue?vue&type=script&lang=ts&"
import style0 from "./Records.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports